





























































import { Vue, Component } from 'vue-property-decorator';
import ConfigSelect from './ConfigSelect.vue';
import ConfigView from './ConfigView.vue';
import ConfigBuyButton from './ConfigBuyButton.vue';
import SingleSelect from '@/components/SingleSelect.vue';
import { TextValuePair } from '@/models/TextValuePair';
import { Configuration, Option, Select, DeliveryTime, Sibling } from '@/models/Configurator';
import ConfigPopup from './ConfigPopup.vue';
import { websiteText } from '@/mixins/websiteTexts';
import { concat, keyBy } from 'lodash';

@Component({
    components: {
        ConfigSelect,
        SingleSelect,
        ConfigView,
        ConfigBuyButton,
        ConfigPopup
    }
})
export default class Configurator extends Vue {
    private dimensions: Array<TextValuePair> = [];
    private selects: Array<Select> = [];
    private configObj: Configuration;
    private selectedDimension: string = '';
    private errors: Array<any> = [];
    private errorMessages: { [key: string]: string } = {
        DoorHinging: websiteText('productpage.article.configurator.doorhinging.required')
    };

    constructor() {
        super();

        this.configObj = this.configurationOptions;
        if (this.configObj.siblings && this.configObj.siblings.length > 0) {
            const selectedDimensionObject = this.configObj.siblings.find(x => x.selected === true) as Sibling;
            this.selectedDimension = selectedDimensionObject.textValue;

            this.dimensions = this.configObj.siblings.map(
                (val: any) =>
                    ({
                        text: val.value,
                        value: val.value
                    } as TextValuePair)
            );
        }

        //console.log(this.configObj);
        if (this.configObj.sinks != null && typeof this.configObj.sinks.options[0] !== 'undefined') {
            const quantityFaucets = this.configObj.sinks.options[0].quantityFaucets;
            this.configObj.faucets.options.forEach(x => (x.quantity = quantityFaucets));
        }
        if (this.configObj.doorHinging != null && typeof this.configObj.doorHinging.options[0] !== 'undefined') {
            const coomentName = this.configObj.doorHinging.options[0].name;
            this.configObj.variants.options.forEach(x => (x.comment = coomentName));
        }
        Object.keys(this.configObj).forEach(key => {
            const currentObj = this.configObj[key as keyof Configuration] as Select;

            if (typeof currentObj !== 'undefined' && currentObj !== null) {
                if (currentObj.options !== undefined && currentObj.options.length > 0) {
                    currentObj.selectedOption = [] as Array<Option>;
                    if (currentObj.selectFirst) {
                        currentObj.selectedOption.push(currentObj.options[0]);
                    } else {
                        if (currentObj.mandatory)
                            this.errors.push({ type: currentObj.type, message: this.errorMessages[currentObj.type] });
                    }
                    if (key === 'variants') {
                        currentObj.open = true;
                        currentObj.main = true;
                    } else {
                        currentObj.open = false;
                        currentObj.main = false;
                    }

                    if (currentObj.hasChild) {
                        for (const opt of currentObj.options) {
                            if (opt.childSelects !== null && typeof opt.childSelects !== 'undefined') {
                                for (const childSelect of opt.childSelects) {
                                    if (childSelect !== null && childSelect.options.length > 0) {
                                        childSelect.selectedOption = [] as Array<Option>;
                                        childSelect.selectedOption.push(childSelect.options[0]);
                                        childSelect.open = false;
                                        childSelect.main = false;
                                    }
                                }
                            }
                        }
                    }
                    this.selects.push(currentObj);
                }
            }
        });
    }
    get configurationOptions(): Configuration {
        const configResult = JSON.parse(this.$attrs['data-configuration']) as Configuration;
        this.$attrs['data-configuration'] = '';
        return configResult;
    }

    get selectedOptions(): Array<Option> {
        const arr1 = this.dynamicSelects
            .filter(y => y.selectedOption.length > 0)
            .map((x: Select) => {
                return x.selectedOption as Array<Option>;
            });
        return Array.prototype.concat.apply([], arr1);
    }
    get deliveryText(): string {
        let text = '';
        if (this.selectedOptions.length > 0) {
            const id = Math.max(...this.selectedOptions.filter(y => y !== null).map(x => x.deliveryTimeId));
            const deliveryTime = this.configObj.deliveryTimes.find(x => x.id == id) as DeliveryTime;
            text = deliveryTime.name;
        }
        return text;
    }

    get dynamicSelects(): Array<Select> {
        const returnArray = [] as Array<Select>;

        for (const select of this.selects) {
            if (typeof select !== 'undefined') {
                returnArray.push(select);
                if (select.selectedOption.length) {
                    for (const selectedOption of select.selectedOption) {
                        //const selectedOption = op as Option;
                        if (
                            selectedOption !== null &&
                            typeof selectedOption !== 'undefined' &&
                            selectedOption.childSelects !== null
                        ) {
                            for (const childSelect of selectedOption.childSelects) {
                                if (
                                    childSelect !== null &&
                                    typeof childSelect !== 'undefined' &&
                                    childSelect.options.length > 0
                                ) {
                                    returnArray.push(childSelect);
                                }
                            }
                        }
                    }
                }
            }
        }

        return returnArray;
    }
    private updateProducts(selProds: number[]) {
        const sibling = this.configObj.siblings.find(x => x.value === selProds[0]) as Sibling;
        window.location.href = sibling.url + '/#configurator';
    }

    private setQuantity(quantity: number) {
        const faucet = this.dynamicSelects.find(x => x.type === 'Faucet') as Select;
        faucet.options.forEach(x => (x.quantity = quantity));
    }

    private setDoorHinging(name: string) {
        const doorHinging = this.dynamicSelects.find(x => x.type === 'DoorHinging') as Select;
        if (!doorHinging.selectFirst) {
            this.showModal(doorHinging);
            doorHinging.selectFirst = true;
            this.errors = this.errors.filter(x => x.type !== doorHinging.type);
        }
        const variant = this.dynamicSelects.find(x => x.type === 'Utf') as Select;
        variant.options.forEach(x => (x.comment = name));
    }
    private showModal(selectedList: Select) {
        const videoWebm = selectedList.infoBox ? selectedList.infoBox.videoWebm : '';
        const videoWebmType = selectedList.infoBox ? selectedList.infoBox.videoWebmType : '';

        const videoMp4 = selectedList.infoBox ? selectedList.infoBox.videoMp4 : '';
        const videoMp4Type = selectedList.infoBox ? selectedList.infoBox.videoMp4Type : '';

        const title = selectedList.infoBox ? selectedList.infoBox.title : '';
        const text = selectedList.infoBox ? selectedList.infoBox.text : '';
        this.$modal.show(
            ConfigPopup,
            { title, text, videoWebm, videoMp4, videoMp4Type, videoWebmType },
            { adaptive: true, styles: { backgroundColor: '#f7f7f7' } }
        );
    }
    private setSelectedList(selectedList: Select) {
        const selectedSelect = this.dynamicSelects.find(x => x.type === selectedList.type) as Select;
        const openedSelect = this.dynamicSelects.find(x => x.type !== selectedList.type && x.open === true) as Select;
        if (typeof openedSelect !== 'undefined') openedSelect.open = false;
        selectedSelect.open = !selectedSelect.open;
    }
}
